import { FormItemPropTypes } from '../form-item/default.js'

const FormItemFileUploadPropTypes = {
  ...FormItemPropTypes,
}

export default FormItemFileUploadPropTypes
